import React from "react";
import { Link } from "react-router-dom";

const FacultyCard = ({ image, title, description, link }) => {
  return (
    <div className="flex flex-col items-center">
      <img
        src={image}
        alt={title}
        className="w-60 h-60 object-cover rounded-lg mb-4"
      />

      <div className="w-60 text-left group">
        <h3 className="text-lg font-bold">{title}</h3>
        <p className="text-sm text-gray-600 mt-1">{description}</p>
        <Link
          to={link}
          className="inline-block mt-1 font-bold text-[rgb(234,126,93)] transition-all duration-300 transform group-hover:translate-x-2 relative group-hover:bg-[rgb(234,126,93)] group-hover:text-white px-0 py-0 group-hover:px-4 group-hover:py-2 after:content-[''] after:block after:h-[2px] after:w-full after:bg-[rgb(234,126,93)] after:mt-1"
        >
          Read More
        </Link>
      </div>
    </div>
  );
};

export default FacultyCard;